<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> Stock </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-tabs v-model="tabs" color="primary" grow>
              <v-tab>Ag Boost</v-tab>
              <v-tab>Espora</v-tab>
              <v-tab-item>
                <StockBio />
              </v-tab-item>
              <v-tab-item>
                <StockMo />
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="red" block @click="closeModal()" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// components
import StockBio from "@/components/dashboard/lote/stock/StockBio";
import StockMo from "@/components/dashboard/lote/stock/StockMo";
export default {
  components: {
    StockBio,
    StockMo,
  },
  data: () => ({
    tabs: 0,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {},
  methods: {
    closeModal() {
      this.show = false;
    },
  },
};
</script>

<style scoped></style>
